import React, { useContext, useEffect, useMemo, useState } from 'react'
import AttendanceCalender from './AttendanceCalender'
import CustomizerContext from '../../../_helper/Customizer'
import { Paper, Popover } from '@mui/material';
import moment from 'moment';
import {
    addDays,
    endOfDay,
    startOfDay,
    startOfYear,
    startOfMonth,
    endOfMonth,
    endOfYear,
    addMonths,
    addYears,
    startOfWeek,
    endOfWeek,
    isSameDay,
    differenceInCalendarDays,
    addWeeks
} from "date-fns";
import { DateRangePicker, defaultStaticRanges, defaultInputRanges } from 'react-date-range';

// import { Spinner } from '../../AbstractElements.jsx';
import { Button } from 'reactstrap';
import { CalendarViewFunctions } from '../../Rates/Components/CalendarViewFunctions';

const DriverAttendanceCalender = ({attendanceData,calendarData,loader,setCalendarData,tableHeaders,setTableHeaders}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [dateLabel, setDateLabel] = useState("This Month")
    const [startDate, setStartDate] = useState(startOfMonth(new Date()));
    const [endDate, setEndDate] = useState(endOfMonth(new Date()));
    const [isSingleDay, setIsSingleDay] = useState(false)

    const { mix_background_layout } = useContext(CustomizerContext)
    useEffect(()=>{
        // console.log("dikedede 22---",calendarData)
    },[])
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    }; 
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const changeCalendarData = async (isSingleDay, startDate, endDate) => {
        setIsLoading(true)
        let newCalendarData = isSingleDay ? await calendarViewFunctions.getAttendanceCalendarData(attendanceData,  true, startDate, endDate) : await calendarViewFunctions.getAttendanceCalendarData(attendanceData,  false, startDate, endDate)
        let newTableHeaders = isSingleDay ? await calendarViewFunctions.getTableHeaderAttendance(startDate, endDate) : await calendarViewFunctions.getTableHeaderAttendance(startDate, endDate)
       console.log(attendanceData,"attendanceERr")
        setCalendarData(newCalendarData)
        setTableHeaders(newTableHeaders)
        setIsLoading(false)
    }
   const calendarViewFunctions = new CalendarViewFunctions()
    const [isLoading, setIsLoading] = useState(false);

    const columns = useMemo(
        () => [
            ...tableHeaders.map(header => (
                header.accessorKey === 'categories' ?
                    {
                        accessorKey: header.accessorKey,
                        header: header.header,
                        size: 150,
                        Header: header?.["Header"],
                        muiTableHeadCellProps: {
                            align: 'center',
                        },
                        muiTableBodyCellProps: {
                            align: 'center',
                        },
                    }
                    :
                    {
                        accessorKey: header.accessorKey,
                        header: header.header,
                        size: 80,
                        Header: header?.["Header"]
                    }
            )),
        ],
        [tableHeaders],
    );
    // -------------------------------------------------
    const handleSelect = (date) => {
        const result = calculateDateRangeFromTwoDates(date);
        console.log("result", result)
        setDateLabel(result.text)
        setStartDate(date.selection.startDate);
        setEndDate(date.selection.endDate);
    };

    const selectionRange = {
        startDate: startDate,
        endDate: endDate,
        key: 'selection',
    }

    const calculateDateRangeFromTwoDates = (ranges) => {
        const beginDate = moment(ranges.selection.startDate);
        const endDate = moment(ranges.selection.endDate);
        const today = moment();
        let text = '';
        let specificTimeSpan = true;
        const duration = moment.duration(endDate.diff(beginDate));
        console.log("duration", duration, duration.get('days'))
        const selectedDateDifference = duration.get('days');

        switch (selectedDateDifference) {
            case 30:
                text = `${moment(ranges.selection.startDate).format('DD/MM/YYYY')} - ${moment(ranges.selection.endDate).format(
                    'DD/MM/YYYY',
                )}`;
                specificTimeSpan = false;
                setIsSingleDay(false)
                break;
            case 29:
                text = moment(endDate).isSame(today, 'month') ? 'This Month' : moment(endDate).isSameOrBefore(today, 'month') ? 'Last Month' : 'Next Month';
                setIsSingleDay(false)
                break;
            case 7:
                text = `${moment(ranges.selection.startDate).format('DD/MM/YYYY')} - ${moment(ranges.selection.endDate).format(
                    'DD/MM/YYYY',
                )}`;
                specificTimeSpan = false;
                setIsSingleDay(false)
                break;
            case 6:
                text = moment(endDate).isSame(today, 'week') ? 'This Week' : moment(endDate).isSameOrBefore(today, 'week') ? 'Last Week' : 'Next Week';
                setIsSingleDay(false)
                break;
            case 1:
                text = `${moment(ranges.selection.startDate).format('DD/MM/YYYY')} - ${moment(ranges.selection.endDate).format(
                    'DD/MM/YYYY',
                )}`;
                specificTimeSpan = false;
                setIsSingleDay(false)
                break;
            case 0:
                text = moment(endDate).isSame(today, 'day') ? 'Today' : moment(endDate).isSame(today.add(-1, 'days').startOf('day'), 'day') ? 'Yesterday' : moment(beginDate).isSame(moment().add(1, 'days').startOf('day'), 'day') ? 'Tomorrow' : `${moment(ranges.selection.startDate).format('DD/MM/YYYY')}`;
                setIsSingleDay(true)
                break;
            default:
                text = `${moment(ranges.selection.startDate).format('DD/MM/YYYY')} - ${moment(ranges.selection.endDate).format(
                    'DD/MM/YYYY',
                )}`;
                specificTimeSpan = false;
                setIsSingleDay(false)
                break;
        }

        return ({
            text,
            specificTimeSpan
        })
    };




    return (
        <Paper sx={{ padding: "10px", backgroundColor: mix_background_layout == "dark-only" ? "#262932" : "#ffffff" }} className='rate-calendar'>
            <div style={{ display: "flex", margin: "15px 0px", justifyContent: "flex-end", alignItems: "center" }}>
                {/* <div className="legend">
                    <div className="individual"><span style={{ background: "rgba(57, 181, 74, 0.7)" }}></span><span>{"Available"}</span></div>
                    <div className="individual"><span style={{ background: "#FFF1E5" }}></span><span>{"Not Available"}</span></div>
                    <div className="individual"><span style={{ background: "#FFE3DF" }}></span><span>{"Priority"}</span></div>
                </div> */}
                <div style={{ width: "220px" }}>
                    <input className="form-control" type="text" onClick={handleClick} value={dateLabel} style={{ cursor: "pointer" }} />
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        // onClose={handleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                    >
                        <DateRangePicker
                            ranges={[selectionRange]}
                            onChange={handleSelect}
                            minDate={addMonths(new Date(startDate), -6)}
                            // maxDate={addMonths(new Date(startDate),2)}
                            inputRanges={[]}
                            staticRanges={[
                                defaultStaticRanges.find((range) => range.label == "Last Month"),
                                defaultStaticRanges.find((range) => range.label == "Last Week"),
                                defaultStaticRanges.find((range) => range.label == "Yesterday"),
                                defaultStaticRanges.find((range) => range.label == "This Month"),
                                defaultStaticRanges.find((range) => range.label == "This Week"),
                                // defaultStaticRanges.find((range) => range.label == "Today"),
                                {
                                    label: "Tomorrow",
                                    range: () => ({
                                        startDate: startOfDay(addDays(new Date(), 1)),
                                        endDate: endOfDay(addDays(new Date(), 1))
                                    }),
                                    isSelected: (range) => {
                                        console.log("isselected range", range)
                                        const definedRange = range;
                                        return (
                                            isSameDay(startOfDay(addDays(new Date(), 1)), definedRange.startDate) &&
                                            isSameDay(endOfDay(addDays(new Date(), 1)), definedRange.endDate)
                                        );
                                    }
                                },
                                {
                                    label: "Next Week",
                                    range: () => ({
                                        startDate: startOfWeek(addWeeks(new Date(), 1)),
                                        endDate: endOfWeek(addWeeks(new Date(), 1))
                                    }),
                                    isSelected: (range) => {
                                        console.log("isselected range", range)
                                        const definedRange = range;
                                        return (
                                            isSameDay(startOfWeek(addWeeks(new Date(), 1)), definedRange.startDate) &&
                                            isSameDay(endOfWeek(addWeeks(new Date(), 1)), definedRange.endDate)
                                        );
                                    }
                                },
                                {
                                    label: "Next Month",
                                    range: () => ({
                                        startDate: startOfMonth(addMonths(new Date(), 1)),
                                        endDate: endOfMonth(addMonths(new Date(), 1))
                                    }),
                                    isSelected: (range) => {
                                        console.log("isselected range", range)
                                        const definedRange = range;
                                        return (
                                            isSameDay(startOfMonth(addMonths(new Date(), 1)), definedRange.startDate) &&
                                            isSameDay(endOfMonth(addMonths(new Date(), 1)), definedRange.endDate)
                                        );
                                    }
                                },
                            ]}
                        />
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", borderTop: "solid 1px #cccccc", margin: "15px", paddingTop: "5px", marginTop: "5px" }}>
                            <Button color="primary" onClick={() => {
                                changeCalendarData(isSingleDay,startDate,endDate)
                                handleClose()
                            }} style={{ marginRight: "10px" }}>OK</Button>
                        </div>
                    </Popover>
                </div>
            </div>
    {/* <div> */}
        <AttendanceCalender 
         calendarData={calendarData}
         calendarColumns={columns}
         isLoading={isLoading}
         mix_background_layout={mix_background_layout}
         loader={loader}
         />
    {/* </div> */}
    </Paper>
  )
}

export default DriverAttendanceCalender